import React from 'react';
import useDateFormat from '../hooks/useDateFormat';

const FormattedDateTime = (props) => {
  const { dateTime, format } = props;
  const date = new Date(dateTime);

  const formatDate = useDateFormat();
  const formattedDate = formatDate(date, format);

  return <time suppressHydrationWarning={true}>{formattedDate}</time>;
};

export default FormattedDateTime;
